<template>
    <div class="visits">
        <h2 class="profile__header">{{ $t('nav.recordsOld') }}</h2>
        <div class="row">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: 'visits-past',
        data() {
          return {};
        },
        created() {
            this.$store.dispatch('getVisits', {visitType: 'diagnostic', bookingStatus: 'CMP'});
        },
        computed: {
            ...mapGetters([
                'consultationsPastCount',
                'diagnosticsPastCount',
            ]),
        },
    }
</script>
